/* Plant Protein PDP (templates/product.plant-protein.json)
   Only runs on elements carrying data-pp-* attributes, so it is inert on every other template. */
(function () {
  if (window.__ppPlantProtein) return;
  window.__ppPlantProtein = true;

  function rupee(cents) {
    var value = Math.round(cents) / 100;
    return '₹' + value.toLocaleString('en-IN', { maximumFractionDigits: value % 1 === 0 ? 0 : 2 });
  }

  /* ---- pack size selector: keeps prices, summary and the add-to-cart form in sync ---- */
  function initBuy(root) {
    if (root.dataset.ppReady) return;
    root.dataset.ppReady = '1';
    var scope = root.closest('.shopify-section') || document;
    var radios = root.querySelectorAll('.pp-pack input');
    var button = root.querySelector('.pp-atc');

    function setText(selector, text) {
      root.querySelectorAll(selector).forEach(function (el) { el.textContent = text; });
    }

    function apply(radio, updateUrl) {
      var data = radio.dataset;
      var price = Number(data.price);
      var compare = Number(data.compare);
      if (!compare || compare < price) compare = price;
      var save = compare - price;

      setText('[data-pp-qty]', data.count + ' ' + (root.dataset.unit || 'Sachets'));
      setText('[data-pp-compare]', rupee(compare));
      setText('[data-pp-price]', rupee(price));
      setText('[data-pp-save]', 'Save ' + rupee(save));
      setText('[data-pp-save-amt]', rupee(save));
      root.querySelectorAll('[data-pp-save], [data-pp-was]').forEach(function (el) { el.hidden = save <= 0; });

      scope.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function (input) {
        input.value = data.variantId;
        input.disabled = false;
      });

      if (button) {
        var soldOut = data.available !== 'true';
        button.disabled = soldOut;
        var label = button.querySelector('span');
        if (label) label.textContent = soldOut ? button.dataset.soldOut : button.dataset.label;
      }

      if (updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', data.variantId);
        window.history.replaceState({}, '', url.toString());
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () { if (radio.checked) apply(radio, true); });
    });
    var current = root.querySelector('.pp-pack input:checked') || radios[0];
    if (current) { current.checked = true; apply(current, false); }

    var offer = root.querySelector('[data-pp-offer]');
    if (offer) {
      var head = offer.querySelector('.pp-offer__head');
      head.addEventListener('click', function () {
        var open = offer.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  /* ---- Ready in 30 seconds: auto-advancing steps ---- */
  function initSteps(root) {
    if (root.dataset.ppReady) return;
    root.dataset.ppReady = '1';
    var steps = root.querySelectorAll('.pp-step');
    var bars = root.querySelectorAll('.pp-steps__bar');
    var media = root.querySelectorAll('.pp-steps__media > [data-pp-step-media]');
    if (!steps.length) return;
    var ms = (Number(root.dataset.interval) || 4) * 1000;
    var index = 0;
    var timer;
    root.style.setProperty('--pp-step-ms', ms + 'ms');

    function go(next) {
      index = (next + steps.length) % steps.length;
      steps.forEach(function (step, i) { step.classList.toggle('is-active', i === index); });
      bars.forEach(function (bar, i) {
        bar.classList.remove('is-active');
        bar.classList.toggle('is-done', i < index);
      });
      if (media.length > 1) {
        media.forEach(function (item, i) { item.classList.toggle('is-active', i === index); });
      }
      void root.offsetWidth;
      if (bars[index]) bars[index].classList.add('is-active');
      clearTimeout(timer);
      timer = setTimeout(function () { go(index + 1); }, ms);
    }

    steps.forEach(function (step, i) {
      step.addEventListener('click', function () { go(i); });
    });
    go(0);
  }

  /* ---- carousels that start on their 2nd card (Real people, real shakes) ---- */
  function initCenter(track) {
    var item = track.children[Number(track.dataset.ppCenter) || 0];
    if (!item || track.scrollWidth <= track.clientWidth) return;
    track.scrollLeft = item.offsetLeft - track.offsetLeft - (track.clientWidth - item.clientWidth) / 2;
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-pp-buy]').forEach(initBuy);
    scope.querySelectorAll('[data-pp-steps]').forEach(initSteps);
    scope.querySelectorAll('[data-pp-center]').forEach(initCenter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
